export default {
  methods: {
    initProducts () {
      const products = this.$store.getters['Products/get']
      if (products.length === 0) {
        this.getProducts().then((products) => {
          return this.setProducts(products)
        }).then(eans => {
          return this.getUpcs(eans)
        }).then(res => {
          // console.log(res.data.data)
          // if (res.data.data.length < 1) console.log(`MODIFACE: has no upc`)
          // else this.$store.dispatch('SDK/setUpcs', res.data.data)
        }).catch(err => {
          console.log(err)
        })
      }
    },
    updateProducts () {
      this.getProducts().then((ans) => {
        return this.setProducts(ans)
      })
    },
    getProducts () {
      return this.$api.get()
    },
    setProducts (products) {
      return this.$store.dispatch('Products/set', products).then(ans => {
        console.log(`DB: PRODUCTS: ${products.length} set`)
        let eans = this.$store.getters['Products/eans']
        return eans
      })
    },
    stockProducts (ean) {
      return this.$api.stock(ean)
    }
  },
  computed: {
    isElectron () {
      return process.env.IS_ELECTRON
    }
  }
}
